module.exports = __webpack_public_path__ + "img/home_black_24dp.9b216682.svg";